var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFeatherPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.001,
    height: 18.035,
    viewBox: "0 0 18.001 18.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M20.167,15.753v2.564a1.71,1.71,0,0,1-1.863,1.71A16.916,16.916,0,0,1,10.927,17.4,16.668,16.668,0,0,1,5.8,12.274,16.916,16.916,0,0,1,3.175,4.863,1.71,1.71,0,0,1,4.876,3H7.44a1.71,1.71,0,0,1,1.71,1.47,10.975,10.975,0,0,0,.6,2.4,1.71,1.71,0,0,1-.385,1.8L8.278,9.761a13.676,13.676,0,0,0,5.129,5.129L14.492,13.8a1.71,1.71,0,0,1,1.8-.385,10.975,10.975,0,0,0,2.4.6,1.71,1.71,0,0,1,1.47,1.735Z",
    transform: "translate(-2.667 -2.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherPhone);
export default __webpack_public_path__ + "static/media/icon-feather-phone.ca89ceab93622dd027066c7bc009a9bb.svg";
export { ForwardRef as ReactComponent };